import React from 'react';
import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { Outlet, useLocation } from "react-router"; // 1. Import useLocation
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import AppSidebar from "./AppSidebar";
//  Import the new footer component
import AppFooter from "./AppFooter";
import AppCardbar from './AppCardbar';
// import MobileTabFooter from './mobileFooterTab';
import SearchOverlay from './SearchOverlay';
import ServiceCategories from './ServiceCategories';

const LayoutContent: React.FC = () => {
    const { isMobileOpen, isCartbarOpen } = useSidebar();
    const location = useLocation(); // 2. Get current location

    // 3. Define condition to hide footer
    const hideFooter = location.pathname.includes('/applicant');

    return (
        // The main container now needs to be a flex column to push the footer down
        <div className="min-h-screen flex flex-col bg-[#F5F5F5] dark:bg-gray-900 text-theme-xxs">
            <AppHeader />
            <div>
                <AppSidebar /> 
                <Backdrop />
                <SearchOverlay />
            </div>

            <div className="flex-1 transition-all duration-300 ease-in-out">
                {/* Safe wrapper – does NOT break sticky */}
                <div className="w-full max-w-full ">
                    {/* Content may create overflow → so hide here only */}
                    <div className="overflow-x-hidden">
                        <Outlet />
                    </div>
                </div>
            </div>

            {isCartbarOpen && <AppCardbar />}

            {/* 4. Conditionally render footer */}
            {!hideFooter && (
                <div className="overflow-x-hidden">
                    <ServiceCategories />
                    <AppFooter />
                </div>
            )}

            {/* <MobileTabFooter /> */}
        </div>
    );
};

const AppLayout: React.FC = () => {
    return (
        <SidebarProvider>
            <LayoutContent />
        </SidebarProvider>
    );
};

export default AppLayout;